/**
 * Components object for customizing HTML elements received from Prismic.
 * Updated for @prismicio/react v3 API.
 *
 * Other than the custom classNames, this follows the Prismic v3 format:
 * https://prismic.io/docs/technologies/rich-text-react
 */

import React from "react"

const htmlSerializer = {
  heading1: ({ children }) => <h1 className="hOne">{children}</h1>,
  heading2: ({ children }) => <h2 className="hTwo">{children}</h2>,
  heading3: ({ children }) => <h3 className="hThree">{children}</h3>,
  heading4: ({ children }) => <h4 className="hFour">{children}</h4>,
  heading5: ({ children }) => <h5 className="hFive">{children}</h5>,
  heading6: ({ children }) => <h6 className="hSix">{children}</h6>,
  paragraph: ({ children }) => <p className="paragraph">{children}</p>,
  strong: ({ children }) => <strong className="strong">{children}</strong>,
  em: ({ children }) => <em className="emphasis">{children}</em>,
  listItem: ({ children }) => <li className="listItem">{children}</li>,
  oListItem: ({ children }) => <li className="oListItem">{children}</li>,
  list: ({ children }) => <ul className="unorderedList">{children}</ul>,
  oList: ({ children }) => <ol className="orderedList">{children}</ol>,
  hyperlink: ({ node, children }) => {
    const targetAttr = node.data?.target ? { target: node.data.target } : {}
    const relAttr = node.data?.target ? { rel: "noopener" } : {}

    // INTERNAL LINKS:
    // The commented out code below is for allowing internal links from Prismic.
    // Enter the complete address for the internal link, in Prismic, then
    // we'll parse the code and apply the correct attributes the element.

    // let href
    // let dataBypass
    // if (node.data.url && node.data.url.includes("marmosetmusic.com/")) {
    //   href = node.data.url.split(".com")[1]
    //   dataBypass = true
    // } else {
    //   href = node.data.url
    //   dataBypass = false
    // }

    const href = node.data?.url || "#"

    return (
      <a href={href} className="hyperLink" {...targetAttr} {...relAttr}>
        {children}
      </a>
    )
  },
  label: ({ node, children }) => {
    const className = node.data?.label
      ? `${node.data.label} label`
      : "label"
    return <span className={className}>{children}</span>
  },
  span: ({ text }) => {
    if (!text) return null
    return text.split("\n").reduce((acc, p, index) => {
      if (index === 0) {
        return [p]
      } else {
        return [...acc, <br key={`br-${index}`} className="span" />, p]
      }
    }, [])
  },
}

export default htmlSerializer
